var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","exact":"","aria-label":_vm.label,"small":_vm.small,"to":_vm.to,"href":_vm.href,"target":_vm.href ? '_blank' : ''}},[_vm._t("default"),(_vm.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.icon))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }